import { ExperienceTemplate } from 'experience-template-renderer-react';

import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';

export const listViewTemplate: ExperienceTemplate = {
  id: 'list-view-large',
  version: '1',
  components: [
    {
      metadata: {
        id: 'ListViewLayout',
      },
      type: 'ListViewLayout',
      children: [
        {
          metadata: {
            id: 'LayoutFlexItemMain',
          },
          type: 'UitkComponent',
          config: {
            type: 'UitkLayoutFlexItem',
            grow: 1,
          },
          children: [
            {
              metadata: {
                id: 'toolbarRegion',
              },
              type: 'ToolbarRegion',
              children: [
                {
                  metadata: {
                    id: 'playback',
                  },
                  type: 'Playback',
                },
              ],
            },
            {
              metadata: {
                id: 'mainRegion',
              },
              type: 'MainRegion',
              children: [
                {
                  metadata: {
                    id: 'mitHeader',
                  },
                  type: 'MitHeader',
                },
                {
                  metadata: {
                    id: 'customerNotificationsAfterHeader',
                  },
                  type: 'CustomerNotificationTemplateComponent',
                  config: {
                    location: CustomerNotificationLocation.AFTER_HEADER,
                  },
                },
                {
                  metadata: {
                    id: 'resultsWrapper',
                  },
                  type: 'ResultsWrapper',
                  children: [
                    {
                      metadata: {
                        id: 'sidebarColumn',
                      },
                      type: 'UitkComponent',
                      config: {
                        type: 'UitkLayoutGridItem',
                        colSpan: 1,
                      },
                      children: [
                        {
                          metadata: {
                            id: 'sidebar',
                          },
                          type: 'Sidebar',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'resultsColumn',
                      },
                      type: 'UitkComponent',
                      config: {
                        type: 'UitkLayoutGridItem',
                        colSpan: 3,
                      },
                      children: [
                        {
                          metadata: {
                            id: 'results-header',
                          },
                          type: 'ResultsHeader',
                        },
                        {
                          metadata: {
                            id: 'search-results',
                          },
                          type: 'SearchResultsWrapper',
                        },
                      ],
                    },
                  ],
                },
                {
                  metadata: {
                    id: 'customerNotificationsFooter',
                  },
                  type: 'CustomerNotificationTemplateComponent',
                  config: {
                    location: CustomerNotificationLocation.FOOTER,
                  },
                },
                {
                  metadata: {
                    id: 'delayedSortAndFilterFetchExperiment',
                  },
                  type: 'DelayedSortAndFilterFetchExperiment',
                },
              ],
            },
          ],
        },
        {
          metadata: {
            id: 'LayoutFlexItemSiderail',
          },
          type: 'UitkComponent',
          config: {
            type: 'UitkLayoutFlexItem',
          },
          children: [
            {
              metadata: {
                id: 'sideRailRegion',
              },
              type: 'SideRailRegion',
              children: [
                {
                  metadata: {
                    id: 'mesoSideRail',
                  },
                  type: 'MesoSideRail',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
